// extracted by mini-css-extract-plugin
export var externalLink = "_dg-0";
export var internalLinkLabel = "_dg-1";